import { useStore } from '@tanstack/react-form';
import { batch } from '@tanstack/store';
import { useCallback, useMemo } from 'react';

import { useFormContext } from './form';

const EMPTY_ERRORS = {};

/**
 * @TODO
 * While forms are being refactored this is a temporary solution for not breaking plugins.
 * To be removed after full migration and plugin fixes
 */
export const useFormAsFormikApi = () => {
  const form = useFormContext();

  const { dirty, values, errors, isValid } = useStore(form.store, (state) => ({
    dirty: state.isDirty,
    values: state.values,
    errors: state.errors?.[0] || EMPTY_ERRORS,
    touched: state.isTouched,
    isValid: state.isValid,
  }));

  const setTouched = useCallback(
    (touchedFields) => {
      batch(() => {
        Object.entries(touchedFields).forEach(([key, isTouched]) => {
          form.setFieldMeta(key, (prev) => ({
            ...prev,
            isTouched,
          }));
        });
      });
    },
    [form],
  );

  const setFieldTouched = useCallback(
    (fieldName, touched) => {
      form.setFieldMeta(fieldName, (prev) => ({
        ...prev,
        isTouched: touched,
      }));
    },
    [form],
  );

  const setValues = useCallback(
    (newValues) => {
      Object.keys(newValues).forEach((key) => {
        form.setFieldValue(key, newValues[key]);
      });
    },
    [form],
  );

  const formProps = useMemo(
    () => ({
      dirty,
      values,
      errors,
      isValid,
      submitForm: form.handleSubmit,
      validateForm: form.validateAllFields,
      resetForm: form.reset,
      setFieldValue: form.setFieldValue,
      setFieldTouched,
      setValues,
      setTouched,
    }),
    [
      dirty,
      errors,
      form.handleSubmit,
      form.reset,
      form.setFieldValue,
      form.validateAllFields,
      isValid,
      setFieldTouched,
      setTouched,
      setValues,
      values,
    ],
  );

  return formProps;
};
